<template>
    <page-title
        icon="bi-gear-fill"
        title="商社マスタ"
    >
    </page-title>

    <section class="section">
        <form @submit.prevent="search()" class="row align-items-end">
            <div class="form-group col-md-8">
                <label>商社名</label>
                <form-input
                    v-model="condition.retailer_name"
                ></form-input>
            </div>
            <div class="col-md-4">
                <button-search
                    text="絞り込み"
                    type="submit"
                    :disabled="loading"
                ></button-search>
            </div>
        </form>
    </section>

    <section class="section">
        <inline-loader v-if="loading"></inline-loader>
        <template v-else>
            <table-normal class="table" optional_class="table-auto">
                <thead>
                    <tr class="table-dark">
                        <th class="col-md-2" v-if="$store.getters['auth/canManageRetailer']()"></th>
                        <th class="col text-center">商社名</th>
                        <th class="col-md-4" v-if="$store.getters['auth/canManageRetailer']()"></th>
                        <th class="col-md-4" v-if="$store.getters['auth/canManageRetailer']()"></th>
                    </tr>
                </thead>
                <template v-if="retailers.length">
                    <draggable
                            v-model="retailers"
                            item-key="retailer_id"
                            tag="tbody"
                            handle=".handle"
                            @end="sort()"
                    >
                        <template #item="{element, index}">
                            <tr>
                                <td class="align-middle text-center handle" v-if="$store.getters['auth/canManageRetailer']()">
                                    <i class="bi bi-chevron-expand"></i>
                                </td>
                                <td class="align-middle">
                                    <form-input
                                        v-if="$store.getters['auth/canManageRetailer']()"
                                        v-model="element.retailer_name"
                                        :required="true"
                                        maxlength="100"
                                        :form="`retailer_${element.retailer_id}`"
                                    ></form-input>
                                    <read-only
                                        v-else
                                        :text="element.retailer_name"
                                        class="text-center"
                                    ></read-only>
                                </td>
                                <td class="align-middle text-end" v-if="$store.getters['auth/canManageRetailer']()">
                                    <form @submit.prevent="update(element)" :id="`retailer_${element.retailer_id}`">
                                        <button-exec-update
                                            text="保存"
                                        ></button-exec-update>
                                    </form>
                                </td>
                                <td class="align-middle" v-if="$store.getters['auth/canManageRetailer']()">
                                    <button-exec-delete
                                        type="button"
                                        @click="$refs.confirm_remove.show(); setTargetRetailer(element, index)"
                                    ></button-exec-delete>
                                </td>
                            </tr>
                        </template>
                    </draggable>
                </template>
                <template v-else>
                    <tbody>
                        <tr>
                            <td></td>
                            <td colspan="2"><alert-no-record></alert-no-record></td>
                        </tr>
                    </tbody>
                </template>
                <tfoot v-if="$store.getters['auth/canManageRetailer']()">
                    <tr>
                        <td class="align-middle"></td>
                        <td class="align-middle">
                            <form-input
                                v-if="$store.getters['auth/canManageRetailer']()"
                                v-model="additional_retailer.retailer_name"
                                :required="true"
                                maxlength="100"
                                form="add_retailer"
                            ></form-input>
                        </td>
                        <td class="align-middle text-end">
                            <template v-if="$store.getters['auth/canManageRetailer']()">
                            <form @submit.prevent="create()" id="add_retailer">
                                <button-exec-create
                                    text="追加"
                                ></button-exec-create>
                            </form>
                            </template>
                        </td>
                        <td></td>
                    </tr>
                </tfoot>
            </table-normal>
        </template>
    </section>

    <confirm-dialog ref="confirm_remove" @ok="remove()">
        <p>削除してよろしいですか？各製品に登録された商社別情報も全て削除されます。ご注意ください。</p>
    </confirm-dialog>

</template>

<script>
import draggable from 'vuedraggable';
import Retailer from '@/models/entities/retailer';
import ConfirmDialog from '@/components/tools/ConfirmDialog.vue';
import InlineLoader from '@/components/tools/InlineLoader.vue';
import FormInput from '@/components/forms/FormInput';
import ReadOnly from '@/components/forms/ReadOnly';
import ButtonSearch from '@/components/buttons/ButtonSearch';
import ButtonExecCreate from '@/components/buttons/ButtonExecCreate';
import ButtonExecUpdate from '@/components/buttons/ButtonExecUpdate';
import ButtonExecDelete from '@/components/buttons/ButtonExecDelete';
import TableNormal from '@/components/tables/TableNormal.vue';
import AlertNoRecord from '@/components/notice/AlertNoRecord.vue';
import PageTitle from '@/components/PageTitle.vue';

export default {
    name: 'Retailer',
    components: {
        draggable,
        ConfirmDialog,
        InlineLoader,
        FormInput,
        ReadOnly,
        ButtonSearch,
        ButtonExecCreate,
        ButtonExecUpdate,
        ButtonExecDelete,
        TableNormal,
        AlertNoRecord,
        PageTitle,
    },
    inject: [
        'startScreenLoading',
        'endScreenLoading',
        'showMessage',
    ],
    data() {
        return {
            //部分ローダー
            loading: false,

            //検索オプション
            condition: {
                retailer_name: null,
            },

            //表示データ
            retailers: [],

            //新規登録規格前置単位
            additional_retailer: new Retailer(),
            //削除対象規格前置単位
            delete_target: {
                retailer: new Retailer(),
                index: null,
            },
        }
    },
    mounted() {
        //storeに前回の検索条件があれば
        this.condition = this.$store.getters['condition/merge']('Retailer', this.condition);
        this.search();
    },
    computed: {
    },
    methods: {
        //検索
        search() {
            //表示データ初期化
            this.retailers.splice(0);
            //部分ローダー
            this.loading = true;

            this.$http.get('/retailer', {
                params: this.condition
            })
            .then(response => {
                for (let row of response.data) {
                    this.retailers.push(new Retailer(row));
                }
                //検索条件を保存
                this.$store.commit('condition/setSearchCondition', {
                    page: 'Retailer',
                    condition: this.condition,
                });
            })
            .finally(() => {
                this.loading = false;
            });
        },
        //削除対象の商社をセットする
        setTargetRetailer(retailer = new Retailer(), index = null) {
            this.delete_target.retailer = retailer;
            this.delete_target.index = index;
        },
        //新規登録
        create() {
            this.startScreenLoading();

            this.$http.post('/retailer', this.additional_retailer)
            .then(response => {
                this.retailers.push(new Retailer(response.data));
                this.additional_retailer = new Retailer();
                this.showMessage('追加しました');
            })
            .finally(() => {
                this.endScreenLoading();
            });
        },
        //編集
        update(retailer) {
            this.startScreenLoading();

            this.$http.put(`/retailer/${retailer.retailer_id}`, retailer)
            .then(() => {
                this.showMessage('編集しました');
            })
            .finally(() => {
                this.endScreenLoading();
            });
        },
        //削除
        remove() {
            this.startScreenLoading();

            this.$http.delete(`/retailer/${this.delete_target.retailer.retailer_id}`)
            .then(() => {
                this.retailers.splice(this.delete_target.index, 1);
                this.showMessage('削除しました');

                //値をリセット
                this.setTargetRetailer();
            })
            .finally(() => {
                this.endScreenLoading();
            });
        },
        //並び替え
        sort() {
            this.startScreenLoading();

            //配列順で順番を採番
            this.retailers.forEach((retailer, index) => {
                retailer.priority = index + 1;
            });

            this.$http.put(`/retailer/sort`, this.retailers)
            .then(() => {

            })
            .finally(() => {
                this.endScreenLoading();
            });
        }
    }
}
</script>

<style scoped>

</style>
